import React, { Component } from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import Checkbox from 'react-toolbox/lib/checkbox';
import { Card, CardText } from 'react-toolbox/lib/card';

import { list } from '~/actions/actions';

const defaults = {
  actions: {}
};

class BoxCountChartSettings extends Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      outdata: {
        ...defaults,
        ...props.indata
      }
    };
  }

  componentDidMount() {
    this.onChange();
    list(this.props.dispatch, this.context.apiClient);
  }

  onChange() {
    this.props.onChange(this.state.outdata);
  }

  setOutdataValue(property, value) {
    this.setState(
      { outdata: { ...this.state.outdata, [property]: value } },
      this.onChange
    );
  }

  setActionValue(actionId, checked, key, val) {
    const actions = { ...this.state.outdata.actions };
    if (checked) {
      actions[actionId] = { ...actions[actionId] };
      if (key) {
        actions[actionId][key] = val;
      }
    } else {
      delete actions[actionId];
    }
    this.setState(
      { outdata: { ...this.state.outdata, actions } },
      this.onChange
    );
  }

  render() {
    return (
      <div>
        <Input
          value={this.state.outdata.title}
          onChange={val => this.setOutdataValue('title', val)}
          label="Title"
        />
        <div>
          <div>Select actions to show</div>
          {this.props.actions.map(action => {
            const actionId = action.get('id');
            const currentAction = this.state.outdata.actions[actionId];
            const actionEnabled = typeof currentAction !== 'undefined';
            return (
              <Card>
                <CardText>
                  <Checkbox
                    checked={actionEnabled}
                    label={action.get('name')}
                    onChange={val => this.setActionValue(actionId, val)}
                  />
                  {actionEnabled && (
                    <div>
                      {[
                        { label: 'Not started', value: 'notStarted' },
                        { label: 'Paused', value: 'paused' },
                        { label: 'In progress', value: 'active' }
                      ].map(status => {
                        return (
                          <Checkbox
                            checked={currentAction[status.value]}
                            label={status.label}
                            key={`${actionId}_${status.value}`}
                            onChange={val =>
                              this.setActionValue(
                                actionId,
                                true,
                                status.value,
                                val
                              )
                            }
                          />
                        );
                      })}
                      {/* <Input
                      value={this.state.outdata.actions[actionId].title || ''}
                      onChange={val =>
                        this.setActionValue(actionId, true, 'title', val)
                      }
                      label="Title"
                    /> */}
                    </div>
                  )}
                </CardText>
              </Card>
            );
          })}
        </div>
        {/* <Checkbox
          checked={this.state.outdata.distributor}
          label="Distributor?"
          onChange={val => this.setOutdataValue('distributor', val)}
        /> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  actions: state.getIn(['actions', 'items'])
});

export default connect(
  mapStateToProps,
  null,
  null,
  { pure: false }
)(BoxCountChartSettings);



// WEBPACK FOOTER //
// ./app/widgets.new/BoxCountChart/settings.js